import React, { FunctionComponent, ReactNode, useState } from 'react';
import classNames from 'classnames';
import Arrow from '../Arrow';
import styles from './ContentWrapper.module.css';

interface Props {
  title?: string;
  collapsed?: boolean;
  titleClassName?: string;
  iconClassName?: string;
  bodyClassName?: string;
  className?: string;
  children: ReactNode;
}

const ContentWrapper: FunctionComponent<Props> = ({
  title,
  collapsed,
  titleClassName,
  iconClassName,
  bodyClassName,
  className,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(!collapsed);

  const childrenWithProps = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        className: classNames(styles.body, bodyClassName),
      });
    }
    return child;
  });

  return (
    <div className={classNames(styles.component, className, isOpen && styles.open)}>
      {title && <h2 className={titleClassName}>{title}</h2>}
      <button className={styles.button} onClick={() => setIsOpen(!isOpen)}>
        <Arrow className={classNames(styles.icon, iconClassName)} />
      </button>
      {childrenWithProps}
    </div>
  );
};

export default ContentWrapper;
